import api from 'base/utils/api';
import { ICalculateCouponData, ICalculateCouponList, ICouponList, IObtainedCoupon } from 'mod/coupon/interface';

export const getCouponList = (): Promise<ICouponList> => api.get('/web/personal/coupon/list');

export const calculateCouponList = (data: ICalculateCouponData): Promise<ICalculateCouponList> => {
    return api.post('/web/cart/v2/calculate-coupon-list', {
        data
    })
};

export async function obtainCoupon(couponCode: string): Promise<IObtainedCoupon> {
    return api.post('/web/coupon/obtain', {
        data: { couponCode }
    })
}
